module.exports = __webpack_public_path__ + "img/promote-your-music-release.4e7943bd.jpg";